// Downloads a reviewer-uploaded certificate image (Lyft) directly, instead of generating a PDF.
// The S3 bucket (REACT_APP_AWS_S3_LINK) serves CORS, so fetch -> blob -> <a download> works.
// Returns a promise so callers can run follow-up work (e.g. close/reload) after the download starts.
export const downloadUploadedCertificate = (
  key,
  fileName = "Vehicle-certificate.png"
) => {
  if (!key) return Promise.resolve();
  const url = `${process.env.REACT_APP_AWS_S3_LINK}/${key}?x-request=xhr`;
  return fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobURL = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobURL);
    })
    .catch(() => {});
};
